import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import './Blog.css';

const Blog = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('todos');

  const categories = ['todos', 'mercado', 'legislação', 'dicas', 'tecnologia'];

  const articles = [
    {
      id: 1,
      title: "Como a IA Está Transformando o Mercado de Precatórios",
      excerpt: "Descubra como a Inteligência Artificial está revolucionando a análise e negociação de precatórios, tornando o processo mais rápido e eficiente.",
      category: "tecnologia",
      date: "15 de Março, 2024",
      image: "/logo/hero_background.png",
      readTime: "5 min"
    },
    {
      id: 2,
      title: "Entenda as Mudanças na Legislação de Precatórios em 2024",
      excerpt: "Principais alterações nas regras de pagamento de precatórios e como elas afetam credores e investidores.",
      category: "legislação",
      date: "10 de Março, 2024",
      image: "/logo/hero_background.png",
      readTime: "7 min"
    },
    {
      id: 3,
      title: "5 Dicas Para Vender Seu Precatório com Segurança",
      excerpt: "Orientações essenciais para garantir uma negociação segura e obter o melhor valor pelo seu precatório.",
      category: "dicas",
      date: "5 de Março, 2024",
      image: "/logo/hero_background.png",
      readTime: "4 min"
    },
    {
      id: 4,
      title: "Análise do Mercado de Precatórios no Primeiro Trimestre",
      excerpt: "Tendências, valores médios e perspectivas para o mercado de precatórios nos próximos meses.",
      category: "mercado",
      date: "1 de Março, 2024",
      image: "/logo/hero_background.png",
      readTime: "6 min"
    },
    {
      id: 5,
      title: "Precatórios Federais vs Estaduais: Qual a Diferença?",
      excerpt: "Entenda as principais diferenças entre precatórios federais e estaduais e como isso afeta o pagamento.",
      category: "dicas",
      date: "25 de Fevereiro, 2024",
      image: "/logo/hero_background.png",
      readTime: "5 min"
    },
    {
      id: 6,
      title: "O Papel da RCL no Cálculo de Precatórios",
      excerpt: "Como a Receita Corrente Líquida influencia diretamente nas previsões de pagamento de precatórios.",
      category: "mercado",
      date: "20 de Fevereiro, 2024",
      image: "/logo/hero_background.png",
      readTime: "8 min"
    }
  ];

  const filteredArticles = selectedCategory === 'todos'
    ? articles
    : articles.filter(article => article.category === selectedCategory);

  return (
    <div className="blog-page">
      <Header />

      <main className="main-content">
        {/* Hero Section */}
        <section className="hero-section blog-hero">
          <div className="hero-background">
            <div className="container">
              <div className="hero-content">
                <div className="hero-badge">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                  </svg>
                  Conteúdo Especializado
                </div>

                <h1 className="hero-title">
                  <span className="highlight-text">Blog</span> MICA Capital
                </h1>

                <p className="hero-subtitle">
                  Artigos, análises e insights sobre o mercado de precatórios, legislação e tecnologia.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="categories-section">
          <div className="container">
            <div className="categories-filter">
              {categories.map(category => (
                <button
                  key={category}
                  className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Articles Section */}
        <section className="articles-section">
          <div className="container">
            <div className="articles-grid">
              {filteredArticles.map(article => (
                <article key={article.id} className="article-card">
                  <div className="article-image">
                    <img src={article.image} alt={article.title} />
                    <div className="article-category-badge">{article.category}</div>
                  </div>
                  <div className="article-content">
                    <div className="article-meta">
                      <span className="article-date">{article.date}</span>
                      <span className="article-read-time">{article.readTime} de leitura</span>
                    </div>
                    <h3 className="article-title">{article.title}</h3>
                    <p className="article-excerpt">{article.excerpt}</p>
                    <button className="article-read-more">
                      Ler Mais
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
                      </svg>
                    </button>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter Section */}
        <section className="newsletter-section">
          <div className="container">
            <div className="newsletter-content">
              <h2>Receba Nossos Artigos por Email</h2>
              <p>Cadastre-se para receber as últimas novidades sobre precatórios diretamente no seu email.</p>
              <div className="newsletter-form">
                <input type="email" placeholder="Seu melhor email" className="newsletter-input" />
                <button className="btn btn-primary">Inscrever-se</button>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Blog;
